import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
const hubspotDomain = () => {
  return getFullUrl('app');
};
export function getPaymentLinksUrl() {
  return `${hubspotDomain()}/payment-links/${PortalIdParser.get()}`;
}